<template>
<div class="home-container themeable">
    <div v-if="!isLoad" class="loadingdiv">
        <div class="loadingwhite">
            <img class="loadingimg" src="../../assets/img/pageloading.gif" />
            <div>loading...</div>
        </div>
    </div>
    <myHead v-if="isLoad" class="myhead" @home_reLoad="home_reLoad"></myHead>
    <div class="lay-content" v-if="isLoad">
        <router-view class="lay-router"></router-view>
    </div>
    <myFoot class="myfoot"></myFoot>
    <div style="position:fixed;bottom: 150px;right:2px;z-index:10">
      <!-- <div class="targWord" @mouseover="mouseIn" @mouseleave="mouseOut">
        客服
      </div> -->
      <!-- <img ref="imgCode" src="../../assets/img/kefu.png" alt=""> -->
      <!-- <div class="targWord help" @click="openHelp">
        帮助中心
      </div> -->
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import myHead from "../header/header.vue";
import myFoot from "../footer/footer.vue";
export default {
    components: {
        myHead: myHead,
        myFoot: myFoot
    },
    data() {
        return {
            isLoad: false
        };
    },
    computed: {
        ...mapState([
            'homeReload'
        ])
    },
    created() {
        //刷新操作初始化数据
        let self = this;
        self.$store.dispatch("getUserInfo", {
            callback: () => {
              self.isLoad = true;
              self.$store.commit('activeMenu', self.$router.history.current);
              //console.log('layout-index')
            }
        });
    },
    methods: {
        home_reLoad() {
            this.isLoad = false;
            setTimeout(() => {
                this.isLoad = true
            }, 300);
        },
        openHelp() {
            window.open("https://shimo.im/docs/LEXk5EihniUYL45l/");
        },
        mouseIn() {
            this.$refs.imgCode.style.display = 'block';
        },
        mouseOut() {
            this.$refs.imgCode.style.display = 'none';
        },
    }
};
</script>

<style lang="scss" scoped>
.home-container {
    padding: 50px 0 0;
    transition: all 0.2s linear;
}

.myhead {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 99;
    min-width: 1000px;
}

.myfoot {
    position: fixed;
    width: 200px;
    left: 0;
    bottom: 0;
    z-index: 99;
    padding: 0 20px;
}

.loadingdiv {
    background-image: url(/static/img/login_bg.c9c29c0.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 96%;
    position: absolute;
    background-color: #ffffff;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 99999;
}

.loadingwhite {
    margin: auto;
    width: 160px;
    text-align: center;
    font-size: 24px;
    color: #292929;
    font-weight: bold;
    position: absolute;
    left: 50%;
    margin-left: -80px;
    top: 40%;
    margin-top: -80px;
    box-sizing: content-box;
}

.loadingwhite img {
    width: 100%;
}

.lay-content,
.lay-router {
    height: 100%;
}

.targWord {
    position: fixed;
    bottom: 150px;
    right: 2px;
    color: #fff;
    padding: 10px;
    width: 32px;
    line-height: 16px;
    cursor: pointer;
    z-index: 10;
    writing-mode: vertical-lr;
}
.targWord+img {
    display: none;
    width: 230px;
    height: 230px;
    margin-right: 35px;
}
.help {
    bottom: 68px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue